import { render } from "./NewBacklinks.vue?vue&type=template&id=29a29794&scoped=true"
import script from "./NewBacklinks.vue?vue&type=script&lang=js"
export * from "./NewBacklinks.vue?vue&type=script&lang=js"

import "./NewBacklinks.vue?vue&type=style&index=0&id=29a29794&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a29794"]])

export default __exports__